import React, { FC } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { CustomStyledDatePicker } from './DatePicker.styles';

interface CustomDatePickerProps {
  onChange?: (date: dayjs.Dayjs | null) => void;
  defaultValue?: dayjs.Dayjs | null;
  disabledDate?: (current: dayjs.Dayjs) => boolean;
}

export const CustomDatePicker: FC<CustomDatePickerProps> = ({
  onChange,
  defaultValue,
  disabledDate,
}) => {
  const { t } = useTranslation();
  const defaultDisabled = (current: dayjs.Dayjs) => {
    return current && current.isBefore(dayjs().startOf('day'), 'day');
  };

  const combinedDisabledDate = (current: dayjs.Dayjs) => {
    return defaultDisabled(current) || (disabledDate ? disabledDate(current) : false);
  };

  const handleChange = (date: dayjs.Dayjs | null) => {
    if (onChange) onChange(date);
  };

  return (
    <CustomStyledDatePicker
      data-testid="schedule-date-picker"
      placeholder={t('shared.datePicker.placeholder')}
      value={defaultValue || null}
      onChange={handleChange}
      disabledDate={combinedDisabledDate}
    />
  );
};
